import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierSelfBillingComponent } from './supplier-self-billing.component';

const routes: Routes = [
  { path: '', component: SupplierSelfBillingComponent, data: { title: 'Self-Billing Agreement' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierSelfBillingRoutingModule {}

@NgModule({
  imports: [
    SupplierSelfBillingRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [SupplierSelfBillingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierSelfBillingModule {}
